import ApiServiceBase from "@/services/api/apiServiceBase";
import {PostPrivacy} from "@/definitions/PostPrivacy";
import {normalizePaginated} from "@/services/api/normalizeProfile";
import {normalizeFeedPosts} from "@/services/api/normalizeFeed";

export interface FriendsFeedServiceOptions {
    visibility?: PostPrivacy[];
}

const friendFeedPages = {page: 1};

export class FriendFeedService extends ApiServiceBase {

    private options = {
        visibility: [
            PostPrivacy.Public,
            PostPrivacy.InnerCircle,
            PostPrivacy.XRated,
        ],
    };

    constructor(options: FriendsFeedServiceOptions = {}) {
        super();
        this.options = {...this.options, ...options};
    }

    public async getBefore(_postId?: number): Promise<any> {
        friendFeedPages.page = 1;
        const payload = await this.http?.get('/post_feeds', {
            filter: 'friends',
            page: 1,
            limit: 10,
        });
        return normalizeFeedPosts(normalizePaginated(payload).data);
    }

    public async getAfter(_postId?: number): Promise<any> {
        friendFeedPages.page += 1;
        const payload = await this.http?.get('/post_feeds', {
            filter: 'friends',
            page: friendFeedPages.page,
            limit: 10,
        });
        return normalizeFeedPosts(normalizePaginated(payload).data);
    }
}
